import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { QueryKeys } from 'utils/constants';
import { useConfigContext } from 'providers/ConfigProvider';

export interface TokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export const useGetClientToken = (
  options?: UseQueryOptions<TokenResponse>,
): UseQueryResult<TokenResponse> => {
  const config = useConfigContext();

  const getClientToken = async () => {
    const response = await axios.request<TokenResponse>({
      url: '/api/tokens',
      method: 'POST',
      headers: {
        Authorization: `${config.REACT_APP_APP_ID}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  return useQuery({
    queryKey: [QueryKeys.Tokens],
    queryFn: () => getClientToken(),
    staleTime: 1000 * 60 * 60, // 1h
    ...options,
  });
};
